import { useCallback, useState } from 'react';
import { ApiError } from '../ApiClient';
import {
  GetApiErrorMessage,
  ValidationMessagesMap,
} from '../utils/ValidationMessagesMap';

const defaultGetErrorMessage = (code: string) => code;

export const useMutationErrors = (
  fallbackGetErrorMessage: GetApiErrorMessage = defaultGetErrorMessage,
  groupFn?: (error: ApiError, i: number) => string | undefined
) => {
  const [mutationErrors, setMutationErrors] = useState(
    new ValidationMessagesMap()
  );

  return {
    mutationErrors,
    setMutationErrors: useCallback(
      (apiErrors: ApiError[], getErrorMessage?: GetApiErrorMessage) => {
        setMutationErrors(
          ValidationMessagesMap.fromApiErrors(
            apiErrors,
            getErrorMessage || fallbackGetErrorMessage,
            groupFn
          )
        );
      },
      [fallbackGetErrorMessage, groupFn]
    ),
    clearMutationErrors: useCallback(() => {
      setMutationErrors(new ValidationMessagesMap());
    }, []),
  };
};
